import React from 'react';
import { Card, CardContent, Box, Typography, Avatar } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const StatCard = ({ title, value, change, isIncrease, icon: Icon, color = '#EF6C00', subtitle }) => {
  return (
    <Card
      sx={{
        height: '100%',
        transition: 'all 0.15s ease',
        '&:hover': {
          borderColor: color,
        },
      }}
    >
      <CardContent sx={{ p: '16px !important' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, fontSize: '0.78rem' }}>
            {title}
          </Typography>
          <Avatar
            sx={{
              bgcolor: `${color}14`,
              color: color,
              width: 34,
              height: 34,
              borderRadius: '8px',
            }}
          >
            <Icon sx={{ fontSize: 18 }} />
          </Avatar>
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5, fontSize: '1.25rem', color: 'text.primary' }}>
          {value}
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, flexWrap: 'wrap' }}>
          {change !== undefined && (
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.3,
                px: 0.8,
                py: 0.2,
                borderRadius: '4px',
                bgcolor: isIncrease ? 'success.light' : 'warning.light',
                color: isIncrease ? 'success.dark' : 'warning.dark',
                fontSize: '0.68rem',
                fontWeight: 700,
              }}
            >
              {isIncrease ? <TrendingUp sx={{ fontSize: 12 }} /> : <TrendingDown sx={{ fontSize: 12 }} />}
              <span>{change}</span>
            </Box>
          )}

          {subtitle && (
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500, fontSize: '0.7rem' }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatCard;
